import {getCurrentInstance} from 'vue';
import {useGridEditor} from '@/components/gridEditor/cellEditor/GridEditorSetup.js';

export const useCopyFromExcel = () => {
  const {proxy} = getCurrentInstance();

  const {getRemotePayload} = useGridEditor();

  /**
   * Convert dữ liệu copy data
   * @returns *
   */
  const convertCopyData = e => {
    // Định dạng . , ngăn cách trong số
    let formatOptions = {
      display_decimal: proxy.$store?.state?.dbOption?.dbOptions?.GeneralDecimalSeparator,
      display_thousand: proxy.$store?.state?.dbOption?.dbOptions?.GeneralGroupSeparator,
    };

    try {
      // Lấy dữ liệu clipboard dạng html
      let htmlClipboardData = e.clipboardData.getData('text/html');
      // Xử lý dữ liệu
      let data = convertCopyDataHtml(htmlClipboardData);

      // Property lưu Định dạng ký tự ngăn cách trong excel
      let displayDecimalRule = `mso-displayed-decimal-separator:"\\`;
      let displayThousandRule = `mso-displayed-thousand-separator:"\\`;

      // Xử lý lấy Định dạng ký tự ngăn cách từ clipboardData
      let displayDecimalIndex = htmlClipboardData.indexOf(displayDecimalRule);
      let displayThousandIndex = htmlClipboardData.indexOf(displayThousandRule);

      if (displayDecimalIndex > 0) {
        let displayDecimal = htmlClipboardData[displayDecimalIndex + displayDecimalRule.length];

        formatOptions.display_decimal =
          displayDecimal || proxy.$store?.state?.dbOption?.dbOptions?.GeneralDecimalSeparator;
      }

      if (displayThousandIndex > 0) {
        let displayThousand = htmlClipboardData[displayThousandIndex + displayThousandRule.length];

        formatOptions.display_thousand =
          displayThousand || proxy.$store?.state?.dbOption?.dbOptions?.GeneralGroupSeparator;
      }

      return {clipboardData: data, formatOptions};
    } catch (e) {}

    let rawClipboardData = e.clipboardData.getData('text');

    return {clipboardData: convertCopyDataPlainText(rawClipboardData), formatOptions};
  };

  /**
   * Convert dữ liệu copy data
   * @returns *
   */
  const convertCopyDataPlainText = rawClipboardData => {
    let clipboardData = [];

    // Tách ra thành dòng
    clipboardData = rawClipboardData.split('\r\n');

    // Bỏ dòng trống ở cuối
    if (clipboardData.length > 1 && !clipboardData[clipboardData.length]) {
      clipboardData.length = clipboardData.length - 1;
    }

    // For từng dòng tách theo \t lấy dữ liệu từng ô
    for (let index = 0; index < clipboardData.length; index++) {
      let item = clipboardData[index];
      clipboardData[index] = item.split('\t');
    }

    return clipboardData;
  };

  /**
   * Convert dữ liệu copy data
   * @returns *
   */
  const convertCopyDataHtml = htmlClipboardData => {
    let me = proxy;

    let clipboardData = [];

    let domClipboard = new DOMParser().parseFromString(htmlClipboardData, 'text/html');

    let table = domClipboard.querySelector('table');

    clipboardData = Array.prototype.map.call(table.querySelectorAll('tr'), function (tr) {
      return Array.prototype.map.call(tr.querySelectorAll('td'), function (td) {
        let value = td.getAttribute('sdval');
        if (value == undefined || isNaN(value)) {
          return td.innerText?.trim().replaceAll('\n ', '') || '';
        }

        return parseFloat(value)
          .toString()
          .replaceAll('.', proxy.$store?.state?.dbOption?.dbOptions?.GeneralDecimalSeparator)
          .trim();
      });
    });

    return clipboardData;
  };

  /**
   * Xử lý format lại dữ liệu
   * @param {*} text
   * @param {*} col
   */
  const formatCopyFromExcel = (text, col, formatOptions) => {
    let me = proxy;
    switch (col.columnType) {
      case me.$ms.constant.ColumnType.Number:
        return text
          .replaceAll(formatOptions.display_thousand, '')
          .replaceAll(formatOptions.display_decimal, '.')
          .replaceAll('(', '-')
          .replaceAll(')', '');
      default:
        return text;
    }
  };

  /**
   * Lấy dữ liệu cho combobox trước khi paste dữ liệu
   * nmtuan4 20.10.2023
   */
  const prepareDataBeforePaste = async (pasteData, columnx, propsData) => {
    let me = proxy;
    // Xử lý gọi api lấy các dữ liệu combobox

    let taskLoad = [];
    for (let index = 0; index < me.columnx.length; index++) {
      const col = columnx[index];
      let colPropsData = propsData[col.dataField];
      let mapData = pasteData.map(x => x[col.dataField]).filter(x => x);
      // Đối với các dữ liệu combobox có queryMode là remote cần gọi lấy đủ dữ liệu trước khi copy
      if (colPropsData?.queryMode == 'remote' && typeof colPropsData?.comboboxLoadData == 'function' && mapData.length) {
        taskLoad.push(
          colPropsData.comboboxLoadData(
            getRemotePayload(
              mapData,
              colPropsData.displayField || col.dataField,
              colPropsData.valueField || colPropsData.modelValueField,
            ),
            {},
            col,
          ),
        );
      }
    }
    await Promise.all(taskLoad);

  };

  return {
    convertCopyData,
    formatCopyFromExcel,
    prepareDataBeforePaste,
  };
};
